var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFHeading(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#FCEBE7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16172_5600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3594 6.6172V16.3828H18.3359C18.6056 16.3828 18.8242 16.6014 18.8242 16.8711V17.8477C18.8242 18.1173 18.6056 18.3359 18.3359 18.3359H13.4531C13.1835 18.3359 12.9648 18.1173 12.9648 17.8477V16.8711C12.9648 16.6014 13.1835 16.3828 13.4531 16.3828H14.4297V12.4766H8.57031V16.3828H9.54687C9.81654 16.3828 10.0352 16.6014 10.0352 16.8711V17.8477C10.0352 18.1173 9.81654 18.3359 9.54687 18.3359H4.66407C4.39439 18.3359 4.17578 18.1173 4.17578 17.8477V16.8711C4.17578 16.6015 4.39439 16.3828 4.66407 16.3828H5.64063V6.6172H4.66407C4.39439 6.6172 4.17578 6.39858 4.17578 6.12894V5.15235C4.17578 4.88268 4.39439 4.66406 4.66407 4.66406H9.5469C9.81657 4.66406 10.0352 4.88268 10.0352 5.15235V6.12891C10.0352 6.39858 9.81657 6.6172 9.5469 6.6172H8.57031V10.5234H14.4297V6.6172H13.4531C13.1835 6.6172 12.9648 6.39858 12.9648 6.12891V5.15235C12.9648 4.88268 13.1835 4.66406 13.4531 4.66406H18.336C18.6056 4.66406 18.8242 4.88268 18.8242 5.15235V6.12891C18.8242 6.39858 18.6056 6.6172 18.336 6.6172H17.3594Z",
    fill: "#DE350B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16172_5600"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFHeading);
export default __webpack_public_path__ + "static/media/fHeading.cf064bccb47f26e52d1bc1562a0ec46c.svg";
export { ForwardRef as ReactComponent };